export const TELL_ABOUT_YOURSELF_SURVEY_DEFAULT_DATA = {
  id: '0',
  name: 'tell_about_yourself',
};
export const ENPS_SURVEY_DEFAULT_DATA = {
  id: '1',
  name: 'enps',
};
export const WELCOME_SURVEY = {
  id: '2',
  name: 'welcome_survey',
};
export const G2_SURVEY = {
  id: '3',
  name: 'g2',
};
